export default {
  schoolLogo: '../../assets/logo.png',
  root: 'https://www.ncu.edu.jm/manage/wp-json/wp/v2/',
  root1: 'http://www.ncu.edu.jm/manage/wp-json/wp/v2/',
  news_root: 'http://news.ncu.fm/manage/wp-json/wp/v2',
  rootUrl: 'https://cmsapi.ncu.edu.jm/project/ncuMain/',
  newRootUrl: 'https://manage.ncu.edu.jm/wp-json/data/',
  rootUrlDev: 'https://cmsapi.ncu.edu.jm/',
  keywordUrl: 'https://cmsapi.ncu.edu.jm/keywords/',
  cmsApiUrl: 'https://cmsapi.ncu.edu.jm/',
  strapiApi: 'http://cmsapi.ncu.edu.jm:1337/',
  undergradDegrees: [],
  undergradTedDegrees: [],
  undergradBCESDegrees: [],
  undergradBADegrees: [],
  undergradCNASDegrees: [],
  undergradRTDegrees: [],
  undergradDegree: [],
  randomDegrees: [],
  extensionDegrees: [],
  gradDegrees: [],
  viewDegree: [],
  viewGradDegree: [],
  mRequirements:[],
  careers: [],
  careerslist: [],
  FeatureStoriesList: [],
  FeatureStory: [],
  AllJobsList: [],
  WebBannersList: [],
  JobsList: [],
  newsArticleSlide: [],
  sportsArticleSlide: [],
  viewArticle: [],
  featureStory: [],
  featureStories: [],
  featureStoriesAll: [],
  upcomingEvent:[
    {
      event_image: ""
    }
  ],
  upcomingEvents:[],
  eventsCalendar: {
    august_2018: [],
    september_2018: [],
    october_2018: [],
    november_2018: [],
    december_2018: [],
    january_2019: [],
    february_2019: [],
    march_2019: [],
    april_2019: [],
    may_2019: [],
    june_2019: [],
    july_2018: []
  },
  academicCalendar: {
    august_2018: [],
    september_2018: [],
    october_2018: [],
    november_2018: [],
    december_2018: [],
    january_2019: [],
    february_2019: [],
    march_2019: [],
    april_2019: [],
    may_2019: [],
    june_2019: [],
    july_2018: []
  },

  monthTracker: {},
  d : new Date(),
  month : ['january_2019', 'february_2019', 'march_2019', 'april_2019', 'may_2019', 'june_2019', 'july_2018', 'august_2018', 'september_2018', 'october_2018', 'november_2018', 'december_2018'],
  days: [
    ['S','U','N'],
    ['M','O','N'],
    ['T','U','E'],
    ['W','E','D'],
    ['T','H','U'],
    ['F','R','I'],
    ['S','A','T'],
  ],
  dayIndex: 0,
  dayArray: {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6
  },
  currentMonth: {},
  currentMonthArray:[],
  currentEventsList: [],
  currentAcademicsList: [],
  KeywordResults: [],
  sportsScores: [],
  updatedDirectory: [
    { name: 'Call Operator',matters:'General queries', extensions: '0 (1-876-963-7400 OR 1-876-618-1652)'},
    { name: 'West Jamaica Regional Campus (Montego Bay)', matters:' Montego Bay Campus',extensions: '7035,7037', email: ''},
    { name: 'University Editor’s Office', matters:': Review and editing of all official publications of the university, etc. ',extensions: '7773,7774', email: 'editor@ncu.edu.jm'},
    { name: 'Special Events', matters:': Events planning and logistics, booking events on the NCU Calendar, booking NCU facilities, university hospitality matters',extensions: '', email: 'specialevents@ncu.edu.jm'},
    { name: 'Occupational Health and Safety', matters:'Health, safety, security and disaster concerns and protocols',extensions: '7169 and 7837', email: 'osh@ncu.edu.jm'},
    { name: 'Office of the President', matters:'Overall university matters, VIP visits,etc.',extensions: '7145', email: 'president@ncu.edu.jm'},
    { name: 'North Jamaica Regional Campus (St.Ann\'s Bay)', matters:'St. Ann’s Bay Campus',extensions: '7046', email: ''},
    { name: 'Human Resource Department', matters:'NCU worker matters, NCU job applications',extensions: '7168', email: 'hr@ncu.edu.jm'},
    { name: 'Graduate Studies', matters:'Graduate programmes, recruitment and issues ',extensions: ': 7401, 7403 and 7149', email: 'graduatestudies@ncu.edu.jm'},
    { name: 'East Jamaica Regional Campus (Kingston)',matters:'Kingston Campus Matters', extensions: '7068', email: ''},
    { name: 'Digital Education', matters: 'Online short certificate courses, training', extensions: '7191,7198, 7804 and 7816', email: 'digitaleducation@ncu.edu.jm'},
    { name: 'Corporate Communication, Marketing and Public Relations (CCMPR)',matters:'campus and external notices, NCU branded graphic designs, university publications, university and social media marketing, public relations/marketing planning/consultation, media coverage planning', extensions: '7155', email: 'ccmpr@ncu.edu.jm'},
    { name: 'Alumni Relations, Advancement and Development',matters: 'Alumni matters, capital development/projects and endowments,Homecoming, the NCU InternationalDevelopment Foundation', extensions: '7181', email: ' alumni@ncu.edu.jm'},
    { name: 'Academic Administration - Curriculum Development, Examinations and Assessment', matters: 'Overall academic concerns, requests and information', extensions: '7176 and 7177', email: 'academic@ncu.edu.jm'},
    { name: 'Academic Administration', matters: 'Overall academic concerns, requests and information', extensions: '7175, 7194 and 7195', email: 'academic@ncu.edu.jm'},
    { name: 'Chaplaincy Services', matters: 'Spiritual concerns, programmes, projects and counselling, Monday Chapel',extensions: '7196', email: 'chaplaincyservices@ncu.edu.jm'},
    { name: 'Church Pastor\'s Office', matters: 'Anything concerning the Seventh-day Adventist congregation at NCU, NCU Church Building Complex, Arrange special church services',extensions: '7196', email: 'churchpastor@ncu.edu.jm'},
    { name: 'Curriculum Development, Examination and Assessment Office', extensions: '7176 or 7177', email: 'academic@ncu.edu.jm'},
    { name: 'Financial Affairs - Student Finance',matters: 'Financial queries, concerns and payments', extensions: '7224, 7226 and 7228', email: 'studentfinance@ncu.edu.jm'},
    { name: 'Health and Wellness Department',matters:': Overall health matters, insurance, medicals, medical appointments', extensions: '7477 and 7478', email: 'healthservices@ncu.edu.jm'},
    { name: 'Help Desk - UNISS (University Information System Services)',matters: 'Aeorion issues and support, online and computer related support and services, website matters, phone matters', extensions: '3104', email: 'techsupport@ncu.edu.jm'},
    { name: 'Library (Hiram S. Walters Resource Centre)',matters: 'Overall library matters, electronic databases and other resources', extensions: '7074, 7075 and 7053', email: 'library@ncu.edu.jm'},
    { name: 'United Student Movement (USM)', matters: 'Student government, representation and advocacy, student clubs',extensions: '7248 and 7784', email: 'usm@ncu.edu.jm'},
    { name: 'Department of Teacher Education/Pre-University', matters: 'External/Overseas examination concerns, registration and classes',extensions: '7371', email: 'preuniversity@ncu.edu.jm'},
    { name: 'Recruitment and Admissions', matters: 'Applications, registration queries and support, campus visit, church/school visits, international students',extensions: '7157, 7250, 7253 and 7826', email: 'recruitmentandadmissions@ncu.edu.jm'},
    { name: 'Scholarship and Student Aid', matters: 'Scholarships, grants, student labour',extensions: '7329 and 7330', email: 'scholarshipsandstudentaid@ncu.edu.jm'},
    { name: 'Student Services', matters: 'United Student Movement, student matters and events, discipline and ethos matters, student verification, Thursday assembly, dormitories, etc.',extensions: '7172, 7243 and 7242', email: 'studentservices@ncu.edu.jm'},
    { name: 'Student Engagement and Retention', matters: 'Student engagement and development events and workshops/seminars',extensions: '7257 and 7917', email: 'studentsuccess@ncu.edu.jm'},
    { name: 'University Records (Office of the Registrar / Records Office)', matters: 'NCU student records, transcripts, graduation application and clearance, completion letters, degree instrument distribution',extensions: '7260-6', email: 'Transcripts - transcripts@ncu.edu.jm, General - records@ncu.edu.jm or registrar@ncu.edu.jm'},
  ],
  Dir:[
    {dep:'Academic Administration',ex:'7175'},
    {dep:'Academic Administration',ex:'7194'},
    {dep:'Academic Administration',ex:'7195'},
    {dep:'Academic Administration - Curriculum Dev, Exams & Assessment',ex:'7176 /7177'},
    {dep:'Academic Advisement & Student Success',ex:'7257 / 7917'},
    {dep:'Sorenson Hall Cafeteria',ex:'7272 / 7273'},
    {dep:'FourPoints Café',ex:'7025'},
    {dep:'Campus Upkeep',ex:'7785-6'},
    {dep:'Career Services',ex:'7443'},
    {dep:'Career Services',ex:'7442'},
    {dep:'NCU Call Center',ex:'7843'},
    {dep:'CCMPR (Corporate Communication, Marketing & Public Relations)',ex:'7155'},
    {dep:'CCMPR (Corporate Communication, Marketing & Public Relations)',ex:'7428'},
    {dep:'CCMPR (Corporate Communication, Marketing & Public Relations)',ex:'7158'},
    {dep:'CCRJC',ex:'7820-1'},
    {dep:'Cedar Hall',ex:'7346'},
    {dep:'Cedar Hall',ex:'7348'},
    {dep:'College of Allied Health and Nursing',ex:'7240'},
    {dep:'College of Allied Health and Nursing',ex:'7237'},
    {dep:'Department of Business & Management',ex:'7420'},
    {dep:'Department of Business & Management',ex:'7421'},
    {dep:'Department of Business & Management',ex:'7422'},
    {dep:'College of Natural & Applied Sciences Allied Health & Nursing',ex:'7479'},
    {dep:'College of Natural & Applied Sciences Allied Health & Nursing',ex:'7238'},
    {dep:'College of Natural & Applied Sciences Allied Health & Nursing',ex:'7482'},
    {dep:'UNIVERSITY RELATIONS - Community Relations & Cooperate Affairs',ex:'7249'},
    {dep:'Counselling Center',ex:'7457'},
    {dep:'Counselling Center',ex:'7458'},
    {dep:'Counselling Center',ex:'7459'},
    {dep:'Custodial Services',ex:'7766'},
    {dep:'Custodial Services',ex:'7767'},
    {dep:'Department of Behavioral Sciences',ex:'7356'},
    {dep:'Department of Behavioral Sciences',ex:'7357'},
    {dep:'Department of Behavioral Sciences',ex:'7364'},
    {dep:'Department of Biology, Chemistry & Environmental Sciences',ex:'7481'},
    {dep:'Department of Biology, Chemistry & Environmental Sciences',ex:'7493'},
    {dep:'Department of Biology, Chemistry & Environmental Sciences',ex:'7485'},
    {dep:'Department of Biology, Chemistry & Environmental Sciences',ex:'7759'},
    {dep:'Department of Communication Studies',ex:'7445'},
    {dep:'Department of Communication Studies',ex:'7446'},
    {dep:'Department of Communication Studies',ex:'7449'},
    {dep:'Department of Communication Studies',ex:'7453'},
    {dep:'Department of Continuing Education',ex:'7293-4'},
    {dep:'Department of Dental Hygiene',ex:'7127'},
    {dep:'Department of Dental Hygiene',ex:'7128'},
    {dep:'Department of Facilities Planning & Management',ex:'7370'},
    {dep:'Department of Facilities Planning & Management',ex:'7187'},
    {dep:'Department of Graduate Education & Leadership',ex:'7188'},
    {dep:'Department of Graduate Education & Leadership',ex:'7094'},
    {dep:'Department of Graduate Education & Leadership',ex:'7098'},
    {dep:'Hiram S. Walters Resource Centre',ex:'7074'},
    {dep:'Hiram S. Walters Resource Centre',ex:'7075'},
    {dep:'Hiram S. Walters Resource Centre',ex:'7053'},
    {dep:'Department of Graduate Studies & Research',ex:'7401'},
    {dep:'Department of Graduate Studies & Research',ex:'7403'},
    {dep:'Department of Graduate Studies & Research',ex:'7149'},
    {dep:'Department of Humanities',ex:'7463'},
    {dep:'Department of Humanities',ex:'7464'},
    {dep:'Department of Humanities',ex:'7745'},
    {dep:'Department of Information Sciences',ex:'7276'},
    {dep:'Department of Information Sciences',ex:'7285'},
    {dep:'Department of Information Sciences',ex:'7282'},
    {dep:'Department of Math & Engineering',ex:'7392'},
    {dep:'Department of Math & Engineering',ex:'7393'},
    {dep:'Department of Math & Engineering',ex:'7394'},
    {dep:'Department of Math & Engineering',ex:'7395'},
    {dep:'Department of Medical Technology',ex:'7125'},
    {dep:'Department of Medical Technology',ex:'7390'},
    {dep:'Department of Medical Technology',ex:'7762'},
    {dep:'Department of Medical Technology',ex:'7805'},
    {dep:'Department of Music & Fine Arts',ex:'7749'},
    {dep:'Department of Music & Fine Arts',ex:'7751'},
    {dep:'Department of Music & Fine Arts',ex:'7752'},
    {dep:'Department of Nursing',ex:'7108'},
    {dep:'Department of Nursing',ex:'7109'},
    {dep:'Department of Nursing',ex:'7106'},
    {dep:'Department of Nursing - Kingston Campus',ex:'7065'},
    {dep:'Department of Nursing - Kingston Campus',ex:'7064'},
    {dep:'Department of Nutrition & Dietetics',ex:'7122'},
    {dep:'Department of Nutrition & Dietetics',ex:'7123'},
    {dep:'Department of Nutrition & Dietetics',ex:'7741'},
    {dep:'Department of Teacher Education',ex:'7372'},
    {dep:'Department of Teacher Education',ex:'7373'},
    {dep:'Department of Teacher Education/Pre-University',ex:'7371'},
    {dep:'Development & Community Partnerships',ex:'7824'},
    {dep:'Distance Education',ex:'7191'},
    {dep:'Distance Education',ex:'7198'},
    {dep:'Distance Education',ex:'7804'},
    {dep:'Distance Education',ex:'7816'},
    {dep:'Editors Office',ex:'7773-4'},
    {dep:'Victor Dixon High School',ex:'7799'},
    {dep:'Victor Dixon High School',ex:'7797'},
    {dep:'Ellen G. White Resource Centre',ex:'7769'},
    {dep:'Finance & Industries',ex:'7203-4'},
    {dep:'Finance & Industries-Project Mgmt',ex:'7328'},
    {dep:'Financial Affairs - Accounts',ex:'7217'},

    {dep:'Financial Affairs - Student Finance',ex:'7224'},
    {dep:'Financial Affairs - Student Finance',ex:'7226'},
    {dep:'Financial Affairs - Student Finance',ex:'7228'},

    {dep:'Graduate Counselling Psychology',ex:'7497'},
    {dep:'Graduate Counselling Psychology',ex:'7742'},
    {dep:'Health & Wellness',ex:'7477'},
    {dep:'Health & Wellness',ex:'7478'},
    {dep:'Hilltop Hotel',ex:'7013'},
    {dep:'Human Resource',ex:'7168'},
    {dep:'Human Resource',ex:'7163'},
    {dep:'Human Resource',ex:'7803'},
    {dep:'Institutional Relations',ex:'7358'},
    {dep:'Jamaica Hall',ex:'7331'},
    {dep:'Jamaica Hall',ex:'7333'},
    {dep:'Internal Audit',ex:'7231'},
    {dep:'Jamaica Union (JAMU)',ex:''},
    {dep:'East Jamaica Regional Campus (Kingston Campus)',ex:'7062'},
    {dep:'East Jamaica Regional Campus (Kingston Campus)',ex:'7066'},
    {dep:'East Jamaica Regional Campus (Kingston Campus)',ex:'7068'},
    {dep:'West Jamaica Regional Campus (Montego Bay)',ex:'7031'},
    {dep:'West Jamaica Regional Campus (Montego Bay)',ex:'7032'},
    {dep:'West Jamaica Regional Campus (Montego Bay)',ex:'7033'},
    {dep:'North Jamaica Regional Campus',ex:'7046'},
    {dep:'North Jamaica Regional Campus',ex:'7049'},
    {dep:'North Jamaica Regional Campus',ex:'7042'},
    {dep:'Campus Safety and Security',ex:'7701'},
    {dep:'Campus Safety and Security',ex:'7702'},
    {dep:'Campus Safety and Security',ex:'7703'},
    {dep:'Campus Safety and Security',ex:'7704'},
    {dep:'Morris Entrepreneur Centre',ex:'7433'},
    {dep:'Morris Entrepreneur Centre',ex:'7437'},
    {dep:'NCU Day Care',ex:'7775'},
    {dep:'NCU Day Care',ex:'7780'},
    {dep:'NCU Early Childhood Center',ex:'7776'},
    {dep:'WIC Prep',ex:'7777'},
    {dep:'WIC Prep',ex:'7778'},
    {dep:'WIC Prep',ex:'7779'},
    {dep:'NCU Media Group',ex:'7731'},
    {dep:'NCU Media Group',ex:'7724'},
    {dep:'NCU Media Group',ex:'7711'},
    {dep:'NCU Media Group',ex:'7817'},
    {dep:'NCU Media Group - Kingston',ex:'7067'},
    {dep:'NCU Media Group - Kingston',ex:'7088'},
    {dep:'NCU Media Group - Kingston',ex:'7061'},
    {dep:'NCU Press',ex:'7137'},
    {dep:'NCU Press',ex:'7138'},
    {dep:'NCU Press',ex:'7139'},
    {dep:'NCU Press - Graphics Room',ex:'7141'},
    {dep:'Office of Alumni Relations & Advancement',ex:'7156'},
    {dep:'Office of Alumni Relations & Advancement',ex:'7233'},
    {dep:'Office of Occupational Safety & Health',ex:'7169'},
    {dep:'Office of Occupational Safety & Health',ex:'7837'},
    {dep:'Office of Scholarships & Student Aid',ex:'7329'},
    {dep:'Office of Scholarships & Student Aid',ex:'7330'},
    {dep:'Office of the President',ex:'7181'},
    {dep:'Office of the President',ex:'7145'},
    {dep:'Office of the President',ex:'7146'},
    {dep:'Quality Management & Institutional Research',ex:'7126'},
    {dep:'Quality Management & Institutional Research',ex:'7150'},
    {dep:'Quality Management & Institutional Research',ex:'7417'},
    {dep:'Recruitment & Admissions',ex:'7157'},
    {dep:'Recruitment & Admissions',ex:'7250'},
    {dep:'Recruitment & Admissions',ex:'7253'},
    {dep:'Recruitment & Admissions',ex:'7826'},
    {dep:'Repairs & Maintenance',ex:'7131'},
    {dep:'Repairs & Maintenance',ex:'7133'},
    {dep:'Repairs & Maintenance',ex:'7135'},
    {dep:'School of Religion and Theology',ex:'7406'},
    {dep:'School of Religion and Theology',ex:'7407'},
    {dep:'School of Religion and Theology',ex:'7408'},
    {dep:'Social Development',ex:'7241'},
    {dep:'Special Events & Hospitality Services',ex:'7161'},
    {dep:'Special Events & Hospitality Services',ex:'7162'},
    {dep:'Student Services',ex:'7172'},
    {dep:'Student Services',ex:'7243'},
    {dep:'Student Services',ex:'7242'},
    {dep:'Student Services - Chaplaincy',ex:'7196'},
    {dep:'Student Services - Student Engagement & Retention & Intl Student Services',ex:'7849'},
    {dep:'UNISS',ex:'7300'},
    {dep:'UNISS - Business Lab',ex:'7302'},
    {dep:'UNISS - Help Desk',ex:'3104'},
    {dep:'UNISS- Micro Computer Lab',ex:'7303'},
    {dep:'United Student Movement',ex:'7248'},
    {dep:'United Student Movement',ex:'7784'},
    {dep:'University Business Services',ex:'7015'},
    {dep:'University Business Services',ex:'7221'},
    {dep:'University Business Services',ex:'7017'},
    {dep:'University Business Services - Laundromat',ex:''}

  ]
}
